/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'app.bsky.unspecced.getSuggestedFeedsSkeleton'

export { $nsid }

/** Get a skeleton of suggested feeds. Intended to be called and hydrated by app.bsky.unspecced.getSuggestedFeeds */
const main = l.query(
  $nsid,
  l.params({
    viewer: l.optional(l.string({ format: 'did' })),
    limit: l.optional(
      l.withDefault(l.integer({ minimum: 1, maximum: 25 }), 10),
    ),
  }),
  l.jsonPayload({ feeds: l.array(l.string({ format: 'at-uri' })) }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
